import { handleActions } from 'redux-actions';
import qs from 'qs';

import cloneDeep from 'lodash/cloneDeep';
import _groupBy from 'lodash/groupBy';

import http from '../shared/http';
import intl from '../shared/intl';

import createFilters from '../shared/filters';

import getTableColumns from './components/table/getColumns';
import createCalendar from '../shared/calendar';
import moment from 'moment';
import { getFormValues } from 'redux-form';
import endpoints from '../../config/endpoints';

const calendar = createCalendar({
	namespace: 'affiliateManagersProductivity',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(30, 'days').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const filters = createFilters({
	namespace: 'affiliateManagersProductivity',
	stateNodeName: 'filters',
	queryBuildFunc: () => '',
	listOfFilters: [
		{
			name: 'admin_id',
			title: 'Admins',
			placeholder: 'Add admins',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.ADMINS
			}
		},
		{
			name: 'countries',
			title: 'Countries',
			placeholder: 'Add countries',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: true,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.LOCATION_CODES_WITH_TRAFFIC
			}
		}
	]
});

// actions types
const FETCH_DATA_SUCCESS = 'affiliate-managers-productivity/fetch-data-success';
const FETCH_DATA_ERROR = 'affiliate-managers-productivity/fetch-data-error';

const TOGGLE_PROGRESS_BAR = 'affiliate-managers-productivity/toggle-progress-bar';
const TOGGLE_SORT = 'affiliate-managers-productivity/TOGGLE_SORT';

const APPLY = 'affiliate-managers-productivity/apply';
const CLEAR = 'affiliate-managers-productivity/clear';

// permissions
export const allowedPermissions = {
	affiliateManagersProductivityListAll: 'affiliate_managers_productivity_list_all',
	affiliateManagersProductivityShowMe: 'affiliate_managers_productivity_show_me'
};

// initial state
const initialState = {
	data: null,
	progressBar: false,
	calendar: calendar.initialState,
	filters: filters.initialState,
	sort: {},
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {
			const productivityDateForm = getFormValues('productivityDateForm')(getState());

			const date = productivityDateForm && productivityDateForm.date
				&& productivityDateForm.date.format('YYYY-MM-DDTHH:mm:ss.SSSZ');

			const query = qs.stringify({ date: date || null });
			const report = selectors.getReportType(getState());

			dispatch({ type: TOGGLE_PROGRESS_BAR });

			return http({
				url: `v2/manager-productivity/${report}?${query}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),

		toggleSort: (header) => (dispatch, getState) => {
			dispatch({ type: TOGGLE_SORT, payload: header.index });
		},

		apply: () => (dispatch) => {
			dispatch(actions.fetchData());
		},

		clear: () => ({ type: CLEAR })
	},
	calendar.actions,
	filters.actions
);

// reducers
const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				progressBar: false,
				error: false
			};
		},
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, progressBar: !state.progressBar }),
		[TOGGLE_SORT]: (state, action) => ({
			...state, sort: {
				[action.payload]: !state.sort[action.payload] || state.sort[action.payload] === 'desc' ? 'asc' : 'desc'
			}
		}),
		[APPLY]: (state, action) => {
			return {
				...state,
				showProgressBar: false,
				data: null
			};
		},
		[FETCH_DATA_ERROR]: state => ({
			...state,
			progressBar: false,
			error: true
		}),
		[CLEAR]: state => ({ ...initialState })
	},
	calendar.reducers,
	filters.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getCan: state => () => true,
	getData: state => {
		if (state.affiliateManagersProductivity.data && state.affiliateManagersProductivity.data[0]) {
			return state.affiliateManagersProductivity.data.reduce((acc, val) => {
				let row = acc.concat(
					!val.country
						? {...val, manager: 'Total by ' + val.manager, isBeforeTotal: true}
						: {...val}
				);
				if (!val.country) {
					row = row.concat({...val, isTotal: true });
				}
				return row;
			}, []);
		}
		return state.affiliateManagersProductivity.data;
	},
	getColumns:  state => {
		const tableName = state.routing.locationBeforeTransitions.pathname
			.replace('/affiliate-managers-productivity/', '')
			.replace('/', '');

		return Object.values(getTableColumns(tableName));
	},
	getSort: state => state.affiliateManagersProductivity.sort,
	getColumnGroups:  state => {
		const tableName = state.routing.locationBeforeTransitions.pathname
			.replace('/affiliate-managers-productivity/', '')
			.replace('/', '');

		return _groupBy(Object.values(getTableColumns(tableName)).map(item => item.group));
	},
	getReportType: state => {
		const tableName = state.routing.locationBeforeTransitions.pathname
			.replace('/affiliate-managers-productivity/', '')
			.replace('/', '');

		return tableName;
	},
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.affiliateManagersProductivity.calendar,
		state => state
	)(state),
	getFilters: state => filters.selectors.getFilters(
		state => state.affiliateManagersProductivity.filters,
		state => state
	)(state),
	getProgressBar: state => state.affiliateManagersProductivity.progressBar,
	getIntl: state => intl(state),
	getError: state => state.affiliateManagersProductivity.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliate-managers-productivity/index.js